export default "__VITE_ASSET__TOVRGN4c__"